import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_APPINSIGHTS_KEY, // o usa tu clave directamente
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: {}
    }
  }
});

appInsights.loadAppInsights();

export { appInsights, reactPlugin };